import { useCallback, useState } from 'react'

/**
 * Hook to manage the flow from banner dismissal to showing a CoachMark on the BulkActionsMenu.
 * When the MonthlyCleanupBanner is dismissed or its cleanup completes, this triggers a CoachMark
 * to appear on the BulkActionsMenu trigger to educate users about the alternative way to resolve
 * comments.
 */
export const useBannerToCoachMarkFlow = (): {
  shouldShowCoachMark: boolean
  triggerCoachMark: () => void
  dismissCoachMark: () => void
} => {
  const [shouldShowCoachMark, setShouldShowCoachMark] = useState(false)

  const triggerCoachMark = useCallback(() => {
    setShouldShowCoachMark(true)
  }, [])

  const dismissCoachMark = useCallback(() => {
    setShouldShowCoachMark(false)
  }, [])

  return {
    shouldShowCoachMark,
    triggerCoachMark,
    dismissCoachMark,
  }
}
